<template lang="pug">

</template>

<script>
export default {

}
</script>



// WEBPACK FOOTER //
// Rents.vue?4f28e16e